<div class="h-full rounded-xl border border-gray-100 bg-white shadow-sm">
  <h3
    class="font-lato border-b border-gray-100 px-5 py-4 text-sm font-bold tracking-wide text-blue-950 uppercase"
  >
    {{ title }}
  </h3>

  @if (loading) {
    <div class="flex items-center justify-center py-10">
      <mat-spinner [diameter]="30"></mat-spinner>
    </div>
  } @else if (list.length === 0) {
    <p class="font-lato text-brand-muted px-5 py-8 text-center text-sm">
      {{ emptyMessage }}
    </p>
  } @else {
    <ul class="m-0 list-none divide-y divide-gray-100 p-0">
      @for (item of list; track item.title) {
        <li
          class="flex items-center justify-between gap-3 px-5 py-3"
          [class.cursor-pointer]="item.link != null"
          [class.hover:bg-blue-75]="item.link != null"
          (click)="goLink(item.link)"
        >
          <div class="flex items-center gap-3">
            @if (item.icon != null) {
              <mat-icon
                class="text-brand-muted !flex !h-5 !w-5 !items-center !justify-center !text-xl"
                aria-hidden="true"
                >{{ item.icon }}</mat-icon
              >
            }
            <span class="font-lato text-brand-muted text-sm">{{
              item.title
            }}</span>
          </div>
          <div class="flex items-center gap-2">
            <span class="font-lato text-lg font-bold text-blue-950">{{
              item.value
            }}</span>
            @if (item.link != null) {
              <mat-icon
                class="!flex !h-4 !w-4 !items-center !justify-center !text-base text-blue-700"
                aria-hidden="true"
                >chevron_right</mat-icon
              >
            }
          </div>
        </li>
      }
    </ul>
  }
</div>
